export const routes = [{
  path: '/tema',
  component: () =>
    import(/* webpackChunkName: "tema" */ './components/List'),
  name: 'tema.list',
  meta: {
    requiresAuth: true
  }
}]
